import type { ReactNode } from "react";
type WantedStatusBannerProps = {
  readonly title: string;
  readonly actions?: ReactNode;
};

export function WantedStatusBanner({
  title,
  actions,
}: WantedStatusBannerProps) {
  return (
    <section
      aria-labelledby="wanted-page-title"
      className="bg-background px-4 font-pretendard sm:px-6"
    >
      <div className="flex w-full min-w-0 items-center justify-between gap-4 py-3">
        <h1
          id="wanted-page-title"
          className="font-pretendard text-[24px] font-bold leading-relaxed text-sig"
        >
          {title}
        </h1>
        {actions && <div className="shrink-0">{actions}</div>}
      </div>
    </section>
  );
}
